import React from "react";
import PropTypes from "prop-types";


const Citations = (props) => {

  return (
    <div className = "relevant-documents text-end fs-6 p-3">
        <h5 className = "text-start">Relevant documents</h5>
        {
            props.content.map((doc, i) => (
                <div key = { i } className = "border border-1 border-light border-start-0 border-top-0 pe-3 mb-3">
                    <p className = "fw-bold">Score: { doc.score }</p>
                    <p>{ doc.snippet }</p>
                </div>
            ))
        }
    </div>
  );
};

Citations.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object),
};

export default Citations;